import { ParamsBuilder } from "../types";
import { RowState } from "../types";

export class LookupBuilder implements ParamsBuilder {
  build(row: RowState): object {
    if (!Array.isArray(row.value)) {
      return {};
    }
    const lookupField = row.lookupFieldName ?? "id";
    switch (row.operator) {
      case "containsAny":
        return {
          OR: row.value.map((v) => ({ [row.fieldName]: { some: { [lookupField]: v } } }))
        };
      case "containsOnly":
        return {
          AND: row.value.map((v) => ({ [row.fieldName]: { some: { [lookupField]: v } } }))
        };
      case "containsAll": {
        const includes = row.value.map((v) => ({ [row.fieldName]: { some: { [lookupField]: v } } }));
        const excludes = { [row.fieldName]: { none: { [lookupField]: { notIn: row.value } } } };
        return {
          AND: [...includes, excludes]
        };
      }
      case "notContains":
        return {
          NOT: { OR: row.value.map((v) => ({ [row.fieldName]: { some: { [lookupField]: v } } })) }
        };
      default:
        return {};
    }
  }
}
